import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { JobOpportunityType } from './index';
import {
  COMPANY_ROUTER_PATH,
  JOB_DETAIL_PAGE_ROUTER_PATH,
} from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';
import defaultCompanyLogo from '@/assets/candidate-builder/default-logo.svg';

interface Props {
  data: JobOpportunityType;
  shadow?: string;
  dataEleGroup?: string;
}

const JobOpportunityCard = (props: Props) => {
  const {
    data: {
      id,
      name,
      company: { name: companyName, logo: companyLogo, id: companyId },
      position,
      qualification,
      salary,
      description,
    },
    shadow = 'shadow-[0px_5px_5px_0px_rgba(0,0,0,0.05)]',
    dataEleGroup = 'card_职位',
  } = props;
  const router = useRouter();

  const url = `${JOB_DETAIL_PAGE_ROUTER_PATH}${id}/`;
  const content =
    (position || qualification || description)
      ?.slice(0, 40)
      .replace(/(\n|\r|\r\n)/g, '<br/>') || '';
  const [companyLogoSrc, setCompanyLogo] = React.useState(
    companyLogo || defaultCompanyLogo,
  );

  return (
    <div
      className={`overflow-hidden cursor-pointer border border-white-smoke rounded-lg px-4 py-5 group/card bg-white ${shadow} hover:border-web-blue-500 hover:shadow-black/[0.15]`}
      data-observer-id={id}
      data-ele-id={`${id}_${name}`}
      data-ele-group={dataEleGroup}
      onClick={(e) => {
        trackClickEvent(e);
        router.push(url);
      }}
    >
      <p className="flex items-center justify-between">
        <Link
          className="font-semibold text-base line-clamp-1 max-w-[80%] tablet:group-hover/card:text-web-blue-500"
          title={name}
          href={url}
          onClick={(e) => trackClickEvent(e, true)}
        >
          {name}
        </Link>
        <span
          className="text-orange-600 line-clamp-1 font-semibold"
          title={salary}
        >
          {salary}
        </span>
      </p>
      <div className="flex items-center mt-4 group/item">
        <div
          style={{ position: 'relative' }}
          className="relative w-6 h-6 rounded-md overflow-hidden flex-shrink-0"
        >
          <Image
            src={companyLogoSrc}
            alt={`${companyName}-logo`}
            fill
            style={{
              objectFit: 'contain',
            }}
            onError={() => setCompanyLogo(defaultCompanyLogo)}
          />
        </div>
        <Link
          className="ml-3 text-sm line-clamp-1 group-hover/item:underline"
          title={companyName}
          href={`${COMPANY_ROUTER_PATH}${companyId}/`}
          onClick={(e) => trackClickEvent(e, true)}
          data-ele-id={`${companyId}_${companyName}`}
          data-ele-group={`${dataEleGroup}_company`}
        >
          {companyName}
        </Link>
      </div>
      <p
        className="mt-4 text-xs leading-5 line-clamp-2 break-all"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </div>
  );
};

export default JobOpportunityCard;
